import React, { Component, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { BsCheckCircleFill, BsFillExclamationCircleFill } from 'react-icons/bs';
import { toasterAlert, toasterRemove } from '../redux/toasterSlice';

const Alert: React.FC = () => {
    const toaster = useSelector((state: RootState) => state.alert.toaster)
    const [list, setList] = useState(toaster);
    const dispatch = useDispatch()

    useEffect(() => {
        if (toaster.length) {
            setList([...toaster]);
        }
    }, [toaster]);

    const deleteToast = (id: any) => {
        const listItemIndex = list.findIndex(e => e.id === id);
        list.splice(listItemIndex, 1);

        const toastListItem = toaster.filter(e => e.id !== id);
        // toaster = toastListItem;
        dispatch(toasterRemove(id))
        setList([...list]);
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (toaster.length && list.length) {
                deleteToast(toaster[0].id);
            }
        }, 3000);

        return () => {
            clearInterval(interval);
        }

        // eslint-disable-next-line
    }, [toaster, list]);

    // return (
    //     <>{
    //         toaster !== undefined && toaster.map((toast: any, key) => {
    //             return (
    //                 <CToaster position='top-right' key={'toaster' + key}>
    //                     <CToast
    //                         show={true}
    //                         autohide={3000}
    //                         fade={true}
    //                         color={toast?.type === 'error' ? 'danger' : 'success'}
    //                     >
    //                         <CToastHeader closeButton={true}>
    //                             {toast?.title}
    //                         </CToastHeader>
    //                         <CToastBody>{toast?.message}</CToastBody>
    //                     </CToast>
    //                 </CToaster>
    //             )
    //         })
    //     }
    //     </>
    // );

    return (
        <>
        <div className={'notification-container top-right'}>
        {
            list !== undefined && list.map((toast: any, key) => {
                return (
                    <div
                        key={`toast_${key}`}
                        className={'notification toast top-right'}
                        style={{ backgroundColor: toast.type === 'error' ? '#d9534f' : '#5cb85c' }}
                    >
                        <button onClick={() => deleteToast(toast.id)}>
                            X
                        </button>
                        <div className="notification-image">
                            {/* <img src={toast.icon} alt="" /> */}
                            {toast.type === 'error' ? <BsFillExclamationCircleFill /> : <BsCheckCircleFill />}
                        </div>
                        <div>
                            <p className="notification-title">{toast.title}</p>
                            <p className="notification-message">
                                {toast.message}
                            </p>
                        </div>
                    </div>
                    )
                })
            // })
        }
        </div>
        </>
        // <h1>fdhjsfksjf</h1>
    );
}

export default Alert;
